import React, {useState} from "react";
import Styles from './styles.module.scss';

import listArrowIcon from '../../theme/assets/svg/lp_arrow.svg';
import compIcon from '../../theme/assets/svg/lp_cabinet_power_completed.svg';
import fundsIcon from '../../theme/assets/svg/lp_cabinet_power_funds.svg';
import idoIcon from '../../theme/assets/svg/lp_cabinet_power_ido.svg';
import stakingIcon from '../../theme/assets/svg/lp_cabinet_power_staking.svg';
import {useDispatch, useSelector} from "react-redux";
import {setFreezeOmtModalStatus, setStakeModalStatus} from "../../store/cabinet/action";
import {toast} from "react-toastify";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";


const LaunchpadPower = (props) => {
    const {currentValueId, setCurrentValueId} = props;
    const { t } = useTranslation();
    const navigate = useNavigate();

    const dispatch = useDispatch();

    const userData = useSelector(store => store.cabinet.userData);
    const launchpadMain = useSelector(store => store.cabinet.launchpadMain);


    const [dropStatus, setDropStatus] = useState(false);

    const data = [
        {name: 'omt', value: userData?.user?.token_freezed_amount ? userData?.user?.token_freezed_amount * 1 : '0', id: 1},
        {name: 'index', value: userData?.user?.index_freezed_amount ? userData?.user?.index_freezed_amount * 1 : '0', id: 2},
    ]

    const currentItem = data.find(item => item.id === currentValueId);

    const stakeHandler = () =>{
        if (currentItem?.name === 'omt'){
            if (userData?.user?.is_honee){
                dispatch(setFreezeOmtModalStatus(true))
            } else {
                dispatch(setStakeModalStatus(true));
            }
        } else {
            if (userData?.user?.is_honee){
                window.open("https://honee.technology/index", "_blank", "noopener");
            } else {
                toast('Для заморозки Index войдите с помощью HoneeAI!');
            }
        }

    }

    const valueHandler = (value) =>{
        if (value < 0){
            return '0'
        } else {
            return value;
        }
    }

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap}`}>
                <div className={`${Styles.totalWrap}`}>
                    <div className={`${Styles.totalWrapTitle}`}>{currentItem?.name === 'omt' ? t('Общая ценность OMT') : t('Общая ценность INDEX')}</div>
                    <div className={`${Styles.switchWrap}`}>
                        <div className={`${Styles.switch}`}>
                            <div className={`${Styles.absSwitchList} ${dropStatus ? Styles.absSwitchListActive : null}`}>
                                {data.map((item, index)=>{
                                    return(
                                        <div
                                            className={`${Styles.absSwitchListItem}`}
                                            key={'SwitchListItem' + index}
                                            onClick={()=>{
                                                setCurrentValueId(item.id);
                                                setDropStatus(false);
                                            }}
                                        >
                                            {item.name}
                                        </div>
                                    )
                                })}
                            </div>
                            <div className={`${Styles.posWrap}`} onClick={()=>{setDropStatus(!dropStatus)}}>
                                <div className={`${Styles.value}`}>
                                    {currentItem ? (
                                        <>
                                            {currentItem.value}{' '}
                                            <span>{currentItem.name}</span>
                                        </>
                                    ) : 'Unknown'}
                                </div>
                                <div className={`${Styles.arrow}`}>
                                    <img src={listArrowIcon} alt="arrow"/>
                                </div>
                            </div>
                        </div>
                        {userData?.user?.status_id === 5 ?
                            <div className={`${Styles.note}`}>
                                {t('Поздравляем, вы достигли статуса Diamond и гарантировано получаете участие в следующем IDO!')}
                            </div> :
                            <div className={`${Styles.note}`}>
                                {t('Заморозьте дополнительные')} {currentItem?.name === 'omt' ? valueHandler(Number(launchpadMain?.next_status?.omt_amount) - Number(launchpadMain?.token_freezed_amount)) : valueHandler(Number(launchpadMain?.next_status?.index_amount) - Number(launchpadMain?.index_freezed_amount))} {currentItem?.name === 'omt' ? 'OMT' : 'INDEX'}, {`${t('чтобы достичь уровня')} ${launchpadMain?.next_status?.name} ${t('и увеличить свои шансы на участие в следующем IDO на')}`} {launchpadMain?.next_status?.probability_percentage * 1}%
                            </div>
                        }
                    </div>
                    <div className={`${Styles.btnsWrap}`}>
                        <div className={`${Styles.btn}`} onClick={stakeHandler}>{t('Заморозить')} {currentItem?.name === 'omt' ? 'OMT' : 'INDEX'}</div>
                        <div className={`${Styles.btn}`} onClick={()=>{navigate('/freeze-history')}}>{t('История заморозок')}</div>
                    </div>
                </div>
                <div className={`${Styles.detailsWrap}`}>
                    <div className={`${Styles.detailsItem}`}>
                        <div className={`${Styles.detailsItemName}`}>
                            <div className={`${Styles.detailsItemNameImgWrap}`}>
                                <img src={fundsIcon} alt="Funds Invested"/>
                            </div>
                            <div className={`${Styles.detailsItemNameText}`}>{t('Средств инвестированно')}</div>
                        </div>
                        <div className={`${Styles.detailsItemValue}`}>{launchpadMain?.funds_invested || '0'} USDT</div>
                    </div>
                    <div className={`${Styles.detailsItem}`}>
                        <div className={`${Styles.detailsItemName}`}>
                            <div className={`${Styles.detailsItemNameImgWrap}`}>
                                <img src={stakingIcon} alt="OMT Staked"/>
                            </div>
                            <div className={`${Styles.detailsItemNameText}`}>{currentItem?.name === 'omt' ? 'OMT' : 'INDEX'} {t('Заморожено')}</div>
                        </div>
                        <div className={`${Styles.detailsItemValue}`}>{currentItem?.value}</div>
                    </div>
                    <div className={`${Styles.detailsItem}`}>
                        <div className={`${Styles.detailsItemName}`}>
                            <div className={`${Styles.detailsItemNameImgWrap}`}>
                                <img src={idoIcon} alt="IDOs Participated"/>
                            </div>
                            <div className={`${Styles.detailsItemNameText}`}>{t('Участие в IDO')}</div>
                        </div>
                        <div className={`${Styles.detailsItemValue}`}>{launchpadMain?.idos_participated || '0'}</div>
                    </div>
                    <div className={`${Styles.detailsItem}`}>
                        <div className={`${Styles.detailsItemName}`}>
                            <div className={`${Styles.detailsItemNameImgWrap}`}>
                                <img src={compIcon} alt="Completed IDOs"/>
                            </div>
                            <div className={`${Styles.detailsItemNameText}`}>{t('Завершённые IDO')}</div>
                        </div>
                        <div className={`${Styles.detailsItemValue}`}>{launchpadMain?.completed_idoses || '0'}</div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default LaunchpadPower;